import { render } from "./TableItem.vue?vue&type=template&id=d791a968&scoped=true"
import script from "./TableItem.vue?vue&type=script&lang=ts"
export * from "./TableItem.vue?vue&type=script&lang=ts"

import "./TableItem.vue?vue&type=style&index=0&id=d791a968&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d791a968"

export default script